import { RichTextEditor, useRichTextEditorContext } from '@mantine/tiptap';

import { BubbleMenu } from '@tiptap/react/menus';

import { Group, useMantineTheme } from '@mantine/core';

import RevisionControl from './RevisionControl';

interface Props {
  regenerateDisabled: boolean
  onClickRegenerate: () => void
}
const BubbleToolbarMenu: React.FC<Props> = (props: Props) => {
  const { editor } = useRichTextEditorContext();
  const {
    onClickRegenerate,
    regenerateDisabled
  } = props;

  const { colors } = useMantineTheme();
  const firstItemBorderRadius = { borderRadius: '4px 0px 0px 4px' };
  const lastItemBorderRadius = { borderRadius: '0px 4px 4px 0px' };

  return (
    <BubbleMenu editor={editor ?? undefined}>
      <Group flex={1} gap={8} bg='white' p={8} style={{
        border: `1px solid ${colors.gray[4]}`,
        borderRadius: '8px',
        boxShadow: 'var(--mantine-shadow-md)'
      }}>
        <RichTextEditor.ControlsGroup>
          <RichTextEditor.Bold style={firstItemBorderRadius} />
          <RichTextEditor.Italic />
          <RichTextEditor.Underline />
          <RichTextEditor.Strikethrough style={lastItemBorderRadius} />
        </RichTextEditor.ControlsGroup>
        <RichTextEditor.ControlsGroup>
          <RichTextEditor.H1 style={firstItemBorderRadius} />
          <RichTextEditor.H2 />
          <RichTextEditor.H3 style={lastItemBorderRadius} />
        </RichTextEditor.ControlsGroup>
        <RichTextEditor.ControlsGroup>
          <RichTextEditor.BulletList style={firstItemBorderRadius} />
          <RichTextEditor.OrderedList style={lastItemBorderRadius} />
        </RichTextEditor.ControlsGroup>
        <RichTextEditor.ControlsGroup>
          <RichTextEditor.AlignLeft style={firstItemBorderRadius} />
          <RichTextEditor.AlignCenter />
          <RichTextEditor.AlignRight style={lastItemBorderRadius} />
        </RichTextEditor.ControlsGroup>
        <RichTextEditor.ControlsGroup>
          <RevisionControl
            onClickRegenerate={onClickRegenerate}
            disabled={regenerateDisabled}
          />
        </RichTextEditor.ControlsGroup>
      </Group>
    </BubbleMenu>
  );
};
export default BubbleToolbarMenu;
